import { create } from 'zustand';
import { telegramSignIn, signOut } from '../api/auth';
import { getProfile } from '../api/profile';
import { tokenStore } from '../api/tokenStore';
import { ApiError } from '../api/http';
import type { Profile } from '../domain/types';

type AuthState = {
  status: 'idle' | 'authenticating' | 'loading_profile' | 'authenticated' | 'needs_contact' | 'error';
  profile: Profile | null;
  error: string | null;
  signIn: () => Promise<void>;
  loadProfile: () => Promise<void>;
  logout: () => void;
};

export const useAuthStore = create<AuthState>((set, get) => ({
  status: tokenStore.isAuthenticated() ? 'loading_profile' : 'idle',
  profile: null,
  error: null,

  signIn: async () => {
    set({ status: 'authenticating', error: null });
    try {
      await telegramSignIn();
      set({ status: 'loading_profile' });
      await get().loadProfile();
    } catch (e) {
      if (e instanceof ApiError && e.code === 'telegram_contact_required') {
        // Rider has not shared their phone with the bot yet.
        set({ status: 'needs_contact', error: null });
        return;
      }
      const message = e instanceof ApiError ? e.message : 'Не вдалося увійти';
      set({ status: 'error', error: message });
    }
  },

  loadProfile: async () => {
    try {
      const profile = await getProfile();
      set({ profile, status: 'authenticated', error: null });
    } catch {
      set({ status: 'error', error: 'Не вдалося завантажити профіль' });
    }
  },

  logout: () => {
    signOut();
    set({ status: 'idle', profile: null, error: null });
  },
}));
